module.exports = __webpack_public_path__ + "static/media/ic_categories_ticket.8cb16e6d.svg";